
import ScrollTrigger from 'gsap/ScrollTrigger'

export default class {
  constructor({ selector }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelectorAll(selector)
    this.theme = document.querySelector('body').dataset.theme

    //Methods        
    // this.inView()
    // this.changeSectionColor()

    this.disable()
    this.selector.length && this.enable()
  }

  changeSectionColor() {
    this.selector.forEach(section => {
      this.observer.observe(section)
    })
  }

  inView() {
    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          document.querySelector('body').dataset.theme = entry.target.dataset.themeUpdate
        } else {
          document.querySelector('body').dataset.theme = this.theme
        }
      })
    })
  }


  enable() {
    ScrollTrigger.create({
      id: "theme",
      trigger: this.selector,
      start: "top center",
      end: "bottom top",
      markers: false,
      onToggle: self => {
        document.querySelector('body').dataset.theme = self.isActive ? self.trigger.dataset.themeUpdate : this.theme
      },
    });
  }

  disable() {
    ScrollTrigger.getById("theme")?.kill()
  }
}